import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let heigthUnitMeasure;
addEventListener('setHeigthUnitMeasure', (e) => {
    const ce = e;
    heigthUnitMeasure = ce.detail.heigthUnitMeasure;
});
export const VITAL_SIGN_HEIGHT_UNIT_MEASURE_VALIDATOR = 'vital-sign-height-unit-measure-validator';
async function vitalSignHeightUnitMeasureValidator(value) {
    let valid = false;
    let message = '';
    if (heigthUnitMeasure && heigthUnitMeasure.cd?.length > 0) {
        if (typeof value === 'string') {
            valid = (value.length > 0 && parseFloat(value) >= 0);
        }
        else {
            valid = (value || value >= 0);
        }
    }
    else {
        valid = true;
    }
    if (!valid) {
        message = MessageService.translate('message.height-patient-unity-selected');
    }
    heigthUnitMeasure = undefined;
    return [{
            message: message,
            name: VITAL_SIGN_HEIGHT_UNIT_MEASURE_VALIDATOR,
            valid: valid
        }];
}
export default vitalSignHeightUnitMeasureValidator;
//# sourceMappingURL=vital-sign-heigth-validator.js.map